import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";
import { transparentize } from "polished";
import { IconButton } from "../IconButton";
var fadeIn = /*#__PURE__*/ keyframes("0%{opacity:0;}100%{opacity:1;}");
var appear = /*#__PURE__*/ keyframes("0%{opacity:0;transform:scale(.95);}100%{opacity:1;transform:scale(1);}");
var Backdrop = /*#__PURE__*/ styled("div", {
    target: "ex2jtkn0"
})("position:fixed;top:0;left:0;right:0;bottom:0;z-index:1002;background-color:", function(param) {
    var theme = param.theme;
    return transparentize(0.3, theme.color.secondary100);
}, ";cursor:pointer;animation:", fadeIn, " 0.3s ease-out;");
var Wrapper = /*#__PURE__*/ styled("div", {
    target: "ex2jtkn1"
})("position:fixed;top:0;left:0;right:0;bottom:0;z-index:1002;display:flex;align-items:flex-start;justify-content:center;box-sizing:border-box;", function(param) {
    var theme = param.theme;
    return theme.mq("sm");
}, "{align-items:center;& > div{width:100%;max-width:", function(param) {
    var $width = param.$width;
    return $width === "wide" ? "810px" : "455px";
}, ";}}");
var Content = /*#__PURE__*/ styled("div", {
    target: "ex2jtkn2"
})("display:flex;flex-direction:column;position:relative;z-index:1003;max-height:100vmax;max-height:100vh;overflow:hidden;color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";box-sizing:border-box;", function(param) {
    var theme = param.theme;
    return theme.mq("sm");
}, "{border:1px solid ", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.md;
}, ";box-shadow:", function(param) {
    var theme = param.theme;
    return theme.boxShadow.md;
}, ";max-height:calc(100vh - 2rem);animation:", appear, " 0.3s ease-out;animation-fill-mode:both;}");
var Footer = /*#__PURE__*/ styled("div", {
    target: "ex2jtkn3"
})("padding:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";text-align:center;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural20;
}, ";");
var TitleWrapper = /*#__PURE__*/ styled("header", {
    target: "ex2jtkn4"
})("display:flex;justify-content:", function(param) {
    var hasTitle = param.hasTitle;
    return hasTitle ? "space-between" : "flex-end";
}, ";gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[10];
}, ";padding:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("sm");
}, "{display:block;}", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{padding-left:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";padding-right:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";}");
var Title = /*#__PURE__*/ styled("p", {
    target: "ex2jtkn5"
})("margin:0;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-weight:normal;font-size:1.25rem;line-height:1.5;color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";text-align:left;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{font-size:1.5rem;text-align:center;}");
var ScrollableContent = /*#__PURE__*/ styled("div", {
    target: "ex2jtkn6"
})("padding:0 ", function(param) {
    var theme = param.theme;
    return "".concat(theme.spacing[40], " ").concat(theme.spacing[40]);
}, ";max-height:100%;overflow-y:auto;box-sizing:border-box;background:linear-gradient(\n      ", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, " 30%,rgb(255 255 255 / 0%)\n    ),linear-gradient(\n        rgb(255 255 255 / 0%),", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, " 70%\n      )\n      0 100%,radial-gradient(farthest-side at 50% 0,rgb(0 0 0 / 20%),transparent),radial-gradient(farthest-side at 50% 100%,rgb(0 0 0 / 20%),transparent) 0\n      100%;background-attachment:local,local,scroll,scroll;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";background-repeat:no-repeat;background-size:100% 40px,100% 40px,100% 14px,100% 14px;", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{padding-left:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";padding-right:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";padding-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";}");
var StyledIconButton = /*#__PURE__*/ styled(IconButton, {
    target: "ex2jtkn7"
})("margin-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[10];
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("sm");
}, "{position:absolute;top:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";right:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";}");
export { Backdrop, Content, Footer, ScrollableContent, StyledIconButton, Title, TitleWrapper, Wrapper };
